import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class LinkFlowService extends BaseService{
  private url = 'api/biz-object-parameters/requestId';
  getUrl():string{
    return this.url;
  }
  constructor(http: HttpClient) {
    super(http);
  }
}
